import { render, staticRenderFns } from "./NormalSearchNav228.vue?vue&type=template&id=712c4dbc&scoped=true"
import script from "./NormalSearchNav228.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav228.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c4dbc",
  null
  
)

export default component.exports